import {
  collection,
  addDoc,
  setDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { MaerkeDag, FoedselsDag, EmailAbonnement } from '../types';

/**
 * Add a new mærkedag to Firestore.
 */
export async function tilfoejMaerkeDag(
  data: Omit<MaerkeDag, 'id' | 'oprettetDen'>
): Promise<string> {
  const ref = await addDoc(collection(db, 'maerkeDage'), {
    ...data,
    oprettetDen: serverTimestamp(),
  });
  return ref.id;
}

/**
 * Add a new fødselsdag to Firestore.
 */
export async function tilfoejFoedselsDag(
  data: Omit<FoedselsDag, 'id' | 'oprettetDen'>
): Promise<string> {
  const ref = await addDoc(collection(db, 'foedselsDage'), {
    ...data,
    oprettetDen: serverTimestamp(),
  });
  return ref.id;
}

/**
 * Subscribe to email notifications.
 */
export async function tilmeldNotifikationer(
  data: Omit<
    EmailAbonnement,
    'bekraeftet' | 'bekraeftelsesToken' | 'oprettetDen' | 'sidstOpdateret'
  >
): Promise<void> {
  await setDoc(doc(db, 'emailAbonnementer', data.email), {
    ...data,
    oprettetDen: serverTimestamp(),
    sidstOpdateret: serverTimestamp(),
  });
}

/**
 * Unsubscribe from email notifications.
 */
export async function afmeldNotifikationer(email: string): Promise<void> {
  await deleteDoc(doc(db, 'emailAbonnementer', email));
}

function generateToken(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
